import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';

const Settings = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        </div>
        <div className="p-6 text-center">
          <SettingsIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Account Settings</h2>
          <p className="text-gray-600">Manage your account preferences and privacy settings.</p>
          <p className="text-gray-500 mt-4">This feature is coming soon!</p>
        </div>
      </div>
    </div>
  );
};

export default Settings; 